import { Platform } from "react-native";

let FetchBlob = {
  fetch: ({ httpMethod, signedRequest, file, onProgress, fileType }) => {
    return new Promise(function (resolve, reject) {
      // do a thing, possibly async, then…

      return { respInfo: "yay!" };
    });
  },
  wrap: file => file,
};

if (Platform.OS === "web") {
  const superagent = require("superagent");

  FetchBlob = {
    fetch: ({ httpMethod, signedRequest, file, onProgress, fileType }) => {
      const req = superagent
        .put(signedRequest)
        .set("Content-Type", fileType)
        .send(file)
        .on("progress", onProgress, 500);

      return req;
    },
    wrap: file => file,
  };
} else {
  const RNFetchBlob = require("react-native-blob-util");

  FetchBlob.fetch = ({
    httpMethod,
    signedRequest,
    file,
    onProgress,
    fileType,
  }) => {
    const req = RNFetchBlob?.default
      .fetch(httpMethod, signedRequest, { "Content-Type": fileType }, file)
      .uploadProgress((written, total) => {
        onProgress(written, total);
      })
      .progress((written, total) => {
        onProgress(written, total);
      });

    return req;
  };

  FetchBlob.wrap = RNFetchBlob?.default?.wrap;

  FetchBlob.wrap = RNFetchBlob?.default?.wrap;
}

export default FetchBlob;
